import F1 from "../assets/novus.jpg";
import F2 from "../assets/guardia.png";
import F3 from "../assets/habitad2.png";

const Solicitar = () => {
  const muestras = [
    { text: "Departamentos Novus", img: F1 },
    { text: "Edificio 47 / Guardias de seguridad SPIE", img: F2 },
    { text: "Departamentos Habitad", img: F3 },
  ];

  return (
    <div className="w-full bg-white py-20 px-4 md:px-6 flex flex-col md:grid md:grid-cols-4 items-start gap-6">
      <div className="h-full text-center flex justify-center items-center">
        <h1 className="text-red-700 text-5xl font-bold">
          Muestra de nuestro trabajo
        </h1>
      </div>
      <div className="flex-1 flex gap-6 md:col-span-3">
        {muestras.map((item, index) => (
          <div key={index} className="flex flex-col items-center">
            <img
              src={item.img}
              alt={item.text}
              className="w-64 h-[50vh] object-cover rounded-lg shadow-lg"
            />
            <p className="mt-2 text-red-700 text-2xl text-center">{item.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Solicitar;
